module.exports = __webpack_public_path__ + "static/media/time.0cab80d1.png";